module.exports = __webpack_public_path__ + "media/images/rcpaqap-logo-7006d0c1.svg";